module.exports = __webpack_public_path__ + "static/img/icon_social_youtube.300c7385.svg";